import { Observable } from 'rxjs'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@env'
import { CallingContext } from '@features/seasons/models/seasons.models'
import { Season } from '@core/models/season-competition.models'

@Injectable()
export class SeasonsApi {
  private readonly _http: HttpClient = inject(HttpClient)

  fetchSeasons(includeMatchdays: boolean, callingContext: CallingContext): Observable<{ seasons: Season[] }> {
    const headers = new HttpHeaders({ CallingContext: callingContext })
    return this._http.get<{ seasons: Season[] }>(environment.api.seasonsUrl, {
      params: { includeMatchdays },
      headers
    })
  }
}
